export default [
  {
    path: 'sales-crm/deals',
    name: 'sales-crm:deals',
    component: () => import('@/views/salesCrm/DealsPage.vue'),
    meta: { requiresAuth: true, authArea: 'sales-crm', layout: 'SalesCrmLayout' },
  },
  {
    path: 'sales-crm/clients',
    name: 'sales-crm:clients',
    component: () => import('@/views/salesCrm/ClientsPage.vue'),
    meta: {
      requiresAuth: true,
      authArea: 'sales-crm',
      layout: 'SalesCrmLayout',
    },
  },
  {
    path: 'sales-crm/dictionaries',
    name: 'sales-crm:dictionaries',
    component: () => import('@/views/salesCrm/DictionariesPage.vue'),
    meta: {
      requiresAuth: true,
      authArea: 'sales-crm',
      layout: 'SalesCrmLayout',
    },
  },
  {
    path: 'sales-crm/leads/import',
    name: 'sales-crm:leads-import',
    component: () => import('@/views/salesCrm/LeadImportPage.vue'),
    meta: {
      requiresAuth: true,
      authArea: 'sales-crm',
      layout: 'SalesCrmLayout',
    },
  },
  {
    path: 'sales-crm/proposal-builder',
    name: 'sales-crm:proposal-builder',
    component: () => import('@/views/salesCrm/ProposalBuilderPage.vue'),
    meta: {
      requiresAuth: true,
      authArea: 'sales-crm',
      layout: 'SalesCrmLayout',
    },
  },
  {
    path: 'sales-crm/clients/:clientId/contract',
    name: 'sales-crm:contract-builder',
    component: () => import('@/views/salesCrm/ContractBuilderPage.vue'),
    meta: {
      requiresAuth: true,
      authArea: 'sales-crm',
      layout: 'SalesCrmLayout',
    },
  },
  {
    path: 'sales-crm/statuses',
    name: 'sales-crm:statuses',
    redirect: to => ({
      name: 'sales-crm:dictionaries',
      params: { locale: to.params.locale },
      query: { section: 'stages' },
    }),
  },
];
